import { UnauthApiClient } from "./apiclient";

export default class unauthContentService extends UnauthApiClient {
  async query(param) {
    return this.GET("/contents/top", {
      contentType: param.contentType,
    });
  }

  async get(param) {
    return this.GET(`/contents/${param}`);
  }

  async getSerieById(uuid) {
    return this.GET(`/series/${uuid}`);
  }

  async getByCategory(param) {
    return this.GET(`/contents/top/bycategory/${param.id}`, {
      // contentType: param.contentType,
      contentType: 'series',
    });
  }
}
